module.exports = fox._r("images/avatar.jpg", __webpack_public_path__ + "images/avatar.jpg");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-file-loader!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/file-loader?name=[path][name].[ext]!./images/avatar.jpg
// module id = 981
// module chunks = 4